import { cn } from "@/lib/utils";

/**
 * Lightweight progress bar; percent in [0, 100]. Doesn't pull in the
 * @radix-ui/react-progress package since we don't need an ARIA progressbar
 * for a simple usage indicator.
 */
export function Progress({
  percent,
  className,
  tone = "brand",
}: {
  percent: number;
  className?: string;
  tone?: "brand" | "warn" | "danger";
}) {
  const clamped = Math.max(0, Math.min(100, percent));
  const fill =
    tone === "danger"
      ? "bg-destructive"
      : tone === "warn"
        ? "bg-amber-500"
        : "bg-bitrefinery-red";
  return (
    <div
      className={cn(
        "relative h-1.5 w-full overflow-hidden rounded-full bg-muted",
        className,
      )}
    >
      <div
        className={cn("h-full transition-all", fill)}
        style={{ width: `${clamped}%` }}
      />
    </div>
  );
}
